export const environment = {
	auth0: {
		clientId: '9wz9cWCqS0oMigNnqXqZ0ASw3aV5e8Qf',
		domain: 'oauth.streeme.io',
	},
	headerImageUrl:
		'https://iam-service.streeme.io/v1/organizations/{id}/images/home-header.jpg',
	svgUrl: 'https://iam-service.streeme.io/v1/organizations/{id}/svgs/{file}',
	websocketUrl:
		'wss://c6ytqqx0tb.execute-api.eu-west-3.amazonaws.com/production',
	styleUrl:
		'https://iam-service.streeme.io/v1/organizations/{id}/public-style/v2.css',
	cvUrl: 'https://content-service.streeme.io/v1/users/{id}/resume/{theme}',
	availableLocales: [
		{ lang: 'en', flag: 'gb' },
		{ lang: 'fr', flag: 'fr' },
		{ lang: 'pt-br', flag: 'br' },
	],
	statisticsGraphQLUri: 'https://statistics-service.streeme.io/graphql',
	messagingGraphQLUri: 'https://messaging-service.streeme.io/graphql',
	contentGraphQLUri: 'https://content-service.streeme.io/graphql',
	contentRestApiBaseUrl: 'https://content-service.streeme.io/v1',
	iamGraphQLUri: 'https://iam-service.streeme.io/graphql',
	iamRestApiBaseUrl: 'https://iam-service.streeme.io/v1',
	headerPicturePlaceholder: '/assets/images/icon-header-user.svg',
	profilePlaceholder: '/assets/images/icon-user.svg',
	visioWebsiteUrl: 'https://visio.streeme.io/',
	authWebsiteUrl: 'https://auth.streeme.io/',
	clientWebsiteUrl: 'https://client.streeme.io/',
	calendarStartTime: { hours: 7, minutes: 0 },
	calendarEndTime: { hours: 18, minutes: 0 },
	calendarInterval: { hours: 1, minutes: 0 },
	tokens: { coach: null, coachee: null },
	currencies: ['EUR', 'USD'],
	autoConnectionRole: null,
	domain: 'my.streeme.io',
	logRocketEnabled: true,
	defaultLocale: 'en',
	production: true,
};
